import React from 'react';
import { LogOut } from 'lucide-react';
import { AuthResponse } from '../services/api';
import NotificationBell from './NotificationBell';

type User = AuthResponse['user'];

const pageTitleMap: Record<string, string> = {
    '/dashboard': 'Dashboard',
    '/drivers': 'Drivers',
    '/sites': 'Sites',
    '/reports': 'Reports',
    '/user-management': 'User Management',
    '/settings': 'Settings',
};

interface AppHeaderProps {
    currentPath: string;
    user: User;
    onLogout: () => void;
    onConsentResultsClick: (data: any) => void;
}

const AppHeader: React.FC<AppHeaderProps> = ({ currentPath, user, onLogout, onConsentResultsClick }) => {
    const pageTitle = Object.entries(pageTitleMap).find(([path]) => currentPath.startsWith(path))?.[1] ?? 'Dashboard';

    return (
        <header className="border-b border-gray-100 flex-shrink-0 print:hidden">
            <div className="px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <span className="text-gray-900 font-bold text-lg">{pageTitle}</span>
                    {process.env.NODE_ENV === 'development' && (
                        <span className="px-2 py-0.5 text-xs font-medium text-white rounded-full" style={{ backgroundColor: '#69BE28' }}>
                            Dev
                        </span>
                    )}
                </div>
                <div className="flex items-center gap-3">
                    <NotificationBell onConsentResultsClick={onConsentResultsClick} />
                    <span className="text-sm text-gray-600 hidden sm:block">Welcome, {user.firstName}</span>
                    <span className="px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded">
                        {user.role}
                    </span>
                    <button
                        onClick={onLogout}
                        title="Logout"
                        className="p-1.5 text-gray-400 hover:text-gray-700 transition-colors rounded-lg hover:bg-gray-100"
                    >
                        <LogOut className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </header>
    );
};

export default AppHeader;
